

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { Address } from 'cluster';
import { FamilyLink } from '../../interfaces/patient-services/family-link';

export interface PatientRegistrationParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface PatientRegistration {
    organizationId:number;
    frroNumber? : string,
    referral?: any;
    physician?: any;
    employee?: any;
    id?: any;
    tenantId: any;
    branchId: any;
    regDate: any;
    regNum:string;
    nHID: string;
    aaadhar: string;
    firstname: string;
    middlename: string;
    lastname?: string;
    title: string;
    gender: string;
    age:number;
    dob:any;
    bloodGroup: string;
    email: string;
    mobile: string;
    landline: string;
    officePhone: string;
    doorno: string;
    address1: string;
    address2: string;
    city: string;
    district: any
    state: any
    country: any
    pincode: string
    maritalStatus: string;
    partnername: string;
    parentOrGuardianName: string;
    preferredlanguage: any;
    altContactPersonName: string;
    patientOccupation: any;
    altContactPersonMobile: string;
    altContactPersonLandline: string;
    altContactPersonAddress: string;
    altRelationship: string;
    refMode: string;
    refEmpId: any;
    refDocId: any;
    cityAreaId?:number;
    refClinicId:any;
    lock: boolean;
    othersPhone: string;
    othersName: string;
    othersAddress: string;
    tourPassportNumber: string;
    tourSSN: string;
    tourVisaDate: any;
    tourVisaValidityDate: any;
    tourNationalIdNumber: string;
    tourCitizenship: string;
    tourPortOfEntry: string;
    tourDateOfEntry: any;
    tourResidentialAddress: string;
    tourOfficeAddress: string;

    altMobileCountryCode: string;
    mobileCountryCode: string;
    drivingLicenseNumber: string;
    officePhoneCountryCode: string;

    status:string;
    parameters?: PatientRegistrationParameter[];
    links?: any;
    updatedBy? : any;
    //Added by Anandh Ravichandran sept 30 2021
    templateId?:string;
    saveFamilyLink?: FamilyLink[];
    //Added for Growth chart DOB **ANANDH RAVICHANDRAN JAN 20 2022
    ageYear:number;
    ageMonth:number; 
    ageDay:number;
    ageDescription: string;
    dobFlag: string;
    ageResult:Date;
	//Added a new field - abirami 25/1
    howDoUKnowAboutUs:any;
    birthplaceId:number;
    birthTime: string;
    panCard: string;
    regionId:number;
    // Reset Fields added
    resetFromDate?:Date;
    resetToDate?:Date;

    registrationServiceId?:string;
    autoPostRegistrationChargesFlag?:string;
    registrationCharge?:string;
    registrationDoctorId?:string;
    createdBy?:string;
    villageId?: number;
    
    specialCare?: number;
    specialCourtesy?: number;
    genderExtension?:string;
    deceasedFlag?:boolean;
    deceasedReasonId?:number;
    deceasedNotes?:string;
    isActive?: string;
    // santhosh 27-4-25
    approvalId?: any;
    approvalDet?:any;
    isEditRegDate?: boolean;
    occupationId?:any;
    studyId?:any;
    remarks?: any;
    refRegId?:any;
    searchPatMobile?:any;
    searchRegId?: any;
    createdDate?: Date;
    entryFrom?:string;
    isunregisterPatientConverted?:boolean;
    tempRegNumber?:string;
    referredBy?:string;
   referralcampid?:any;
   nationalityId?:string;
   citizenshipId?:string;
   refugeeNo?:string;
   iqamaNo?:string;
   guardianName?:string,
   guardianMobilenumber?:string,
   guardianLandline?:string,
   guardianAddress?:string,
   guardianRelationship?:number,
   guardianPhoneCountryCode?:string,
}


export interface PatientDataFromABHA {
    ABHANumber:string;
    address:string;
    email:string;
    firstName:string;
    gender:string;
    lastName:string;
    middleName:string;
    mobile:string;
    pincode:string;
    townName:string;
    dayOfBirth:string;
    monthOfBirth:string;
    yearOfBirth:string;
    healthIdNumber:string;
    healthId:string;
    abhaAddress:string;
    abhaNumber:string;
    districtName:string;
    stateName:string;
    preferredAbhaAddress : string;
}
export abstract class PatientRegistrationData {
    abstract getById(url: string): Observable<PatientRegistration>;
    abstract getCommData(url: string): Observable<any>;
    abstract list(url: string): Observable<any>;
    abstract sendMessage(url: string, data: any): Observable<any>;
    abstract sendMessageOtp(url: string,data: any): Observable<any>; 
    abstract sendMessageOtp1(url: string): Observable<any>; 
    abstract create(url: string, data: PatientRegistration): Observable<PatientRegistration[]>;
    abstract update(url: string, data: PatientRegistration): Observable<PatientRegistration>;
    abstract delete(url: string): Observable<any>;

    abstract getPhyList(url: string): Observable<any>;
    abstract getEmpList(url: string): Observable<any>;
    abstract getLabList(url: string): Observable<any>;
    abstract getOtherList(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;

    //sendMsg
    abstract sendgreetingsMessage(url: string, data: any): Observable<any>;
    abstract send_email(url: string, data:any): Observable<any[]>;
        
    abstract getReason(url: string): Observable<any>;
}
